import React, { createContext, useContext } from 'react';
import { useDisclosure } from '@mantine/hooks';
import AgendaFlow from './AgendaFlow';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { useNavigate } from 'react-router';
import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';

type AgendaContextType = {
  opened: boolean;
  open: () => void;
  close: () => void;
};

const AgendaContext = createContext<AgendaContextType>({} as AgendaContextType);

export function useAgenda() {
  const context = useContext(AgendaContext);
  if (context === undefined) {
    throw new Error('useAgenda must be used within an AgendaProvider');
  }
  return context;
}

export default function AgendaProvider({ children }: { children: React.ReactNode }) {
  const [opened, { open: disclosureOpen, close }] = useDisclosure(false);
  const { flagEnabledNewLayout } = useFlags();
  const { client } = useCurrentClientIfAvailable();
  const navigate = useNavigate();

  const value = {
    opened,
    open: () => {
      if (flagEnabledNewLayout) {
        navigate(`/client/${client?.id}/meeting-agenda`, {
          state: { fromPath: location.pathname },
        });
        return;
      }
      disclosureOpen();
    },
    close,
  };

  return (
    <AgendaContext value={value}>
      {children}
      <AgendaFlow opened={opened} close={close} />
    </AgendaContext>
  );
}
